import React from 'react'

import { RichText } from '../../helpers/react'
import { Card, Icon } from '../../../atoms'
import Button from '../../../atoms/button'

const CallOutCard = ({ content, jsonBody = {}, brand, sys, rawName, variant }) => {
  return (
    <Card
      className='CallOutCard'
      style={{
        backgroundColor: jsonBody.backgroundColor,
      }}
    >
      {(jsonBody.iconText || jsonBody.icon) && (
        <div
          className='CallOutCard-top-cta-wrapper'
          style={{
            backgroundColor: jsonBody.ctaBackgroundColor,
            color: jsonBody.ctaColor,
            borderColor: jsonBody.ctaBorderColor,
            border: jsonBody.ctaBorderColor ? '1px solid' : 'none',
          }}
        >
          <div className='CallOutCard-top-cta-wrapper-inner'>
            {jsonBody.icon && (
              <div className='CallOutCard-icon-wrapper'>
                <Icon glyph={jsonBody.icon} brand={brand} ariaLabel={jsonBody.icon} size={24} />
              </div>
            )}
            {jsonBody.iconText && (
              <span style={{ color: jsonBody.ctaColor }}>{jsonBody.iconText}</span>
            )}
          </div>
        </div>
      )}
      <RichText content={content.content} />
      {jsonBody.button && (
        <Button
          variant={jsonBody.button.variant}
          size='md'
          href={jsonBody.button.href}
          dataClickTracking={{
            component_category: 'platinum-component',
            component_id: sys?.id,
            component_name: 'call-out',
            contentful_name: rawName,
            contentful_variant: variant,
          }}
        >
          {jsonBody.button.text}
        </Button>
      )}
    </Card>
  )
}

export default CallOutCard
